import styled from 'styled-components';
import Alert from '@material-ui/lab/Alert';

// CONSTANTS
import { BITTERSWEET_2, RADICAL_RED } from '@/constants/colors';

// UTILITY
import breakpoints from '@/utility/breakpoints';

export const StyledErrorAlert = styled(Alert)`
  position: relative;

  padding: 16px;

  color: ${RADICAL_RED};
  background: ${BITTERSWEET_2};
  border: 1px solid ${RADICAL_RED};
  border-radius: 16px;

  text-align: left;

  .MuiAlertTitle-root {
    margin-bottom: 8px;
  }

  .MuiAlert-icon {
    color: inherit;
    margin-top: -3px;

    .MuiSvgIcon-root {
      width: 28px;
      height: 28px;
    }

    ${breakpoints.up('sm')} {
      display: flex;
    }
  }

  .MuiAlert-action {
    position: absolute;
    margin: 0;
    top: 0;
    right: 0;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export default StyledErrorAlert;
